export default {
  "content": "<path fill=\"#7E8391\" fill-rule=\"evenodd\" d=\"M1.478 14.924a.824.824 0 001.093-.403l1.976-4.28 1.635 1.635a.832.832 0 00.727.229.827.827 0 00.603-.466l1.892-4.1 1.643 2.19a.815.815 0 00.79.32.832.832 0 00.65-.553l2.47-7.412a.819.819 0 00-.52-1.042.823.823 0 00-1.042.521l-1.973 5.92-1.528-2.036a.822.822 0 00-.746-.325.838.838 0 00-.393.15.835.835 0 00-.268.324l-1.975 4.28-1.636-1.634a.829.829 0 00-.727-.229.823.823 0 00-.603.466l-2.47 5.353a.824.824 0 00.402 1.092z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "none"
  }
};